import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { authAPI } from '../utils/api';

const Login = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [passwort, setPasswort] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    
    try {
      const result = await authAPI.login(email, passwort);
      
      if (result.success) {
        localStorage.setItem('autogutachter24_user', JSON.stringify(result.user));
        localStorage.setItem('autogutachter24_token', result.token);
        navigate('/dashboard');
      } else if (result.requires_approval) {
        // User is pending approval
        setError(result.message || 'Ihr Konto wartet noch auf Freischaltung durch den Administrator.');
      } else {
        setError(result.message || 'Anmeldung fehlgeschlagen.');
      }
    } catch (err) {
      if (err.response && err.response.data && err.response.data.detail) {
        setError(err.response.data.detail);
      } else {
        setError('Anmeldung fehlgeschlagen. Bitte versuchen Sie es erneut.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center relative overflow-hidden bg-gradient-to-br from-blue-50 to-purple-50">
      {/* Background Pattern */}
      <div className="absolute inset-0 z-0 opacity-10">
        <div className="absolute top-20 left-20 w-72 h-72 bg-blue-400 rounded-full mix-blend-multiply filter blur-xl animate-blob"></div>
        <div className="absolute top-40 right-20 w-72 h-72 bg-purple-400 rounded-full mix-blend-multiply filter blur-xl animate-blob animation-delay-2000"></div>
        <div className="absolute bottom-20 left-40 w-72 h-72 bg-pink-400 rounded-full mix-blend-multiply filter blur-xl animate-blob animation-delay-4000"></div>
      </div>

      {/* Login Container - Alles zentriert */}
      <div className="relative z-10 w-full flex flex-col items-center">
        {/* Logo - zentriert */}
        <div className="text-center mb-8">
          <img 
            src="/logo-new.png" 
            alt="Autogutachter24" 
            className="mx-auto mb-6"
            style={{ width: '600px', height: 'auto' }}
          />
          <p className="text-gray-600 text-lg font-medium">KFZ-Sachverständigen Software</p>
        </div>

        {/* Login Card - zentriert */}
        <div className="w-full max-w-md">
          <div className="bg-white/80 backdrop-blur-lg rounded-3xl shadow-2xl p-10 border border-white">
          
          <form onSubmit={handleLogin} className="space-y-6">
            <div>
              <Input
                type="email"
                placeholder="E-Mail"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                disabled={loading}
                className="h-12 bg-white/50 border-gray-200"
              />
            </div>
            
            <div>
              <Input
                type="password"
                placeholder="Passwort"
                value={passwort}
                onChange={(e) => setPasswort(e.target.value)}
                required
                disabled={loading}
                className="h-12 bg-white/50 border-gray-200"
              />
            </div>

            {error && (
              <div className="text-red-600 text-sm text-center bg-red-50 p-3 rounded-lg">
                {error}
              </div>
            )}

            <Button 
              type="submit"
              disabled={loading}
              className="w-full h-12 bg-gradient-to-r from-blue-500 to-blue-700 hover:from-blue-600 hover:to-blue-800 text-white font-medium transition-all shadow-lg"
            >
              {loading ? 'Anmelden...' : 'Anmelden'}
            </Button>

            {/* Registrierungs-Link */}
            <div className="mt-4 text-center">
              <p className="text-sm text-gray-600">
                Noch kein Account?{' '}
                <button
                  type="button"
                  onClick={() => navigate('/register')}
                  className="text-blue-600 hover:text-blue-700 font-semibold hover:underline"
                >
                  Jetzt registrieren
                </button>
              </p>
            </div>
          </form>
          </div>
        </div>

        {/* Footer */}
        <div className="mt-6 text-center text-sm text-gray-500">
          © 2024 Autogutachter24 - Alle Rechte vorbehalten
        </div>
      </div>
    </div>
  );
};

export default Login;